import React,{useState} from 'react'
import { toast } from 'react-toastify'
import Modal from '../../../components/Modal'
import { TOAST_CONFIG, TUTOR_REG_CALL_STATUS } from '../../../config/constants'

export default function AddCallLog({data,onSubmit,setData,setModal}) {

    // const [data,setData] = useState({status:0,reason:'',description:''})
    const [loading,setLoading] = useState(false)

  return (
    <Modal title="Add Call Log" size="md">
        <form id='addCallLog' className="modal-inner-content" onSubmit={(e)=>onSubmit(e)}>
        <div className='input-group'>
            <label>Call Info</label>
            <select value={data.description} defaultChecked={data.description} required onChange={(e)=>setData(prev=>({...prev,description:e.target.value}))}>
                <option value=''></option>
                {
                    TUTOR_REG_CALL_STATUS.map((item,index)=>
                    {
                        return <option key={index} value={item.status}>{item.statusName}</option>
                    })
                }
            </select>
        </div>
        </form>
        <div className="modal-footer">
            <button type='button' className="xs-neutral-btn" onClick={()=>setModal(false)}>Cancel</button>
            <button form='addCallLog' className="xs-delete-btn" type='submit' disabled={loading}>Add</button>
        </div>
    </Modal>
  )
}
